<template src="./Checkout.html"/>
<style lang="scss" scoped src="./Checkout.scss"/>

<script>


import CartPreview from '@/components/Checkout/CartPreview';
import Steps from '@/components/Checkout/Steps';


export default {
  name: 'Checkout',
  layout: 'checkout',

  components: {
    Steps,
    CartPreview
  },
  data() {
    return {
      isDone: false,
      anonymousSteps: [
        {name: 'ConnexionCheckout', routeName: 'CheckoutLogin', path: 'connexion', sidebar: false,showProduct:false},
        {name: 'Shipping', routeName: 'CheckoutShipping', path: 'livraison', sidebar: true, showProduct:false},
        {name: 'Payment', routeName: 'CheckoutPayment', path: 'paiement', sidebar: true,showProduct:true}
      ],
      loggedSteps: [
        {name: 'Shipping', routeName: 'CheckoutShipping', path: 'livraison', sidebar: true, showProduct:false},
        {name: 'Payment', routeName: 'CheckoutPayment', path: 'paiement', sidebar: true, showProduct:true}
      ],
      currentStep: null,
      actualSteps: [],
    }
  },

  mounted() {
    this.actualSteps = this.isAuthenticated ? this.loggedSteps : this.anonymousSteps;
    this.getSidebar(this.$route.name);
  },

  computed: {
    isAuthenticated: {
      get() {
        return this.$store.getters.isAuthenticated
      }
    },
    sidebar: {
      get() {
        return this.getSidebar(this.$route.name);
      }
    },
    currentCart: {
      get() {
        return this.$store.getters.getCart
      },
    },
    isThankYou: {
      get() {
        if (this.$route.name === 'CheckoutThankYou') {
          return true;
        } else {
          return false;
        }
      }
    },
    currentStepIndex: {
      get() {
        return this.getIndex(this.$route.name)
      },
      set() {
      }
    },

  }, watch: {
    isAuthenticated(logged) {
      this.changeStep(logged);
    },
    currentCart(newCart) {
      if (!newCart) {
        this.$router.push('/mon-panier').catch();
      }
    }

  },
  methods: {
    isDoneShipping(e) {
      this.isDone = e
    },
    changeStep(logged) {
      this.actualSteps = logged ? this.loggedSteps : this.anonymousSteps;
      this.$router.push('/commande/livraison').catch();
    },

    getSidebar(currentStep) {
      let sidebar = null;
      if (this.actualSteps) {
        Object.keys(this.actualSteps).forEach(key => {
          if (this.actualSteps[key].routeName === currentStep) {
            sidebar = this.actualSteps[key].sidebar;
          }
        });
      }
      return sidebar;
    },

    handleStepClick(stepIndex) {
      const stepKey = Object.keys(this.actualSteps)[stepIndex];
      const stepSelected = this.actualSteps[stepKey];
      this.currentStepIndex = stepIndex;
      if (this.currentStepIndex > stepIndex) {
        if (this.$route.name !== stepSelected.routeName)
          this.$router.push(`/commande/${stepSelected.path}`).catch();
      } else if (this.isDone && this.currentStepIndex < stepIndex) {
        if (this.$route.name !== stepSelected.routeName)
          this.$router.push(`/commande/${stepSelected.path}`).catch();
      }
    },

    getIndex(currentStep) {
      let index = 0;
      if (this.actualSteps) {
        Object.keys(this.actualSteps).forEach(key => {
          if (this.actualSteps[key].routeName === currentStep) {
            index = Object.keys(this.actualSteps).findIndex(s => s === key);
          }
        });
      }
      return index;
    }
  }
};
</script>